const BASE_PATH = '/auth-details'

export const authDetailsOverview = (): string => {
  return BASE_PATH
}
